import { motion } from "framer-motion";

export const EASE = [0.25, 0.1, 0.25, 1];

export function MaskLines({ lines, className = "", lineClassName = "", delay = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Reveal({ children, className = "", delay = 0, y = 32 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function ChapterHeading({ number, title, className = "" }) {
  return (
    <Reveal className={`flex items-baseline gap-4 sm:gap-6 ${className}`}>
      <span className="font-mono text-xs text-terracotta tracking-[0.25em]">{number}</span>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-ink">{title}</h2>
      <span className="hidden sm:block h-px flex-1 bg-ink/15 self-center" />
    </Reveal>
  );
}
